import { useEffect } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'

import { useAppStore } from '@/stores/appStore'

import { ROUTER_PUBLIC_LINKS } from './config'

export function SecureRoute() {
  const isAuthenticated = useAppStore((state) => state.isAuthenticated)
  const isRefreshingToken = useAppStore((state) => state.isRefreshingToken)
  const hasRefreshToken = useAppStore((state) => !!state.refreshToken)
  const navigate = useNavigate()

  useEffect(() => {
    // Don't redirect if:
    // - User is authenticated
    // - Token refresh is in progress
    // - We have a refresh token (can attempt refresh)
    if (!isAuthenticated && !isRefreshingToken && !hasRefreshToken) {
      navigate(ROUTER_PUBLIC_LINKS.auth.path)
    }
  }, [isAuthenticated, isRefreshingToken, hasRefreshToken, navigate])

  return <Outlet />
}
